module.exports = __webpack_public_path__ + "img/tour-2.3b7482e3.png";